/**
 * 찜한 상품 정렬 옵션.
 *
 * iOS/Android는 Firebase RemoteConfig key `sorting_type_in_like` 에서 JSON으로 받지만
 * RN에는 RemoteConfig 직접 접근 브릿지가 없어 fallback 값을 그대로 하드코딩.
 *
 * - iOS  : RemoteConfigFallback.sortingTypeInLike (`낮은 가격순`)
 * - Android: AblyRemoteConfig.SORTING_TYPE_IN_LIKE (`저가순`)
 *
 * 라벨이 갈리는 경우엔 iOS 표기를 우선 채택. 운영에서 변경이 잦아지면 native bridge로 교체.
 */
export interface SortTypeInLike {
  key: string;
  name: string;
}

export const SORTING_TYPE_IN_LIKE: SortTypeInLike[] = [
  { key: 'LIKE_LATEST', name: '담은순' },
  { key: 'POPULAR', name: '인기순' },
  { key: 'LATEST', name: '최신순' },
  { key: 'LOW_PRICE', name: '낮은 가격순' },
  { key: 'MORE_REVIEWS', name: '리뷰 많은순' },
];

export const DEFAULT_SORT_TYPE_IN_LIKE = SORTING_TYPE_IN_LIKE[0];
